const guid = (page) => page.props.user ? page.props?.user?.guid : null

export const fireSCRNEvent = async page => {
  window.dataLayer.push({
    event: 'scrn',
    userId: guid(page), // передать websso profile guid
    userAuth: page.props.user ? 1 : 0,
    screenName: page.url,
    eventContent: null,
    eventContext: null,
    buttonLocation: null,
    filterName: null,
    actionGroup: 'non_interactions',
    productName: null,
    productId: null,
    formId: null,
    touchPoint: 'web'
  })
}

const loginEvent = async page => {
  window.dataLayer.push({
    event: 'vntLogin',
    eventCategory: 'avtorizaciya',
    eventAction: 'confirmed',
    eventLabel: 'uspeshnaya_avtorizaciya',
    eventValue: null,
    userId: guid(page), // передать websso profile guid
    userAuth: page.props.user ? 1 : 0,
    screenName: page.url, // передать путь к странице, это пример для главной
    eventContent: null,
    eventContext: null,
    buttonLocation: null,
    actionGroup: 'conversions',
    productName: null,
    productId: null,
    formId: null,
    touchPoint: 'web'
  })

}

export const loginClickEvent = (event = {}, eventLinkElement) => {
  eventLinkElement.preventDefault()
  window.dataLayer.push({
    event: 'vntLogin',
    eventCategory: 'avtorizaciya',
    eventAction: 'button_click',
    eventLabel: 'voiti',
    eventValue: null,
    userId: null,
    userAuth: null,
    screenName: window.location.pathname, // передать путь к странице, это пример для главной
    eventContent: 'voiti',
    eventContext: 'screen | popup',
    buttonLocation: null,
    actionGroup: 'interactions',
    productName: null,
    productId: null,
    formId: null,
    touchPoint: 'web',
    ...event
  })

  setTimeout(() => {
    window.location.href = eventLinkElement.target.href
  }, 500)

}
export const callEvent = async page => {
  if (page.props?.ga_event === undefined) return
  if (page.props.ga_event === null) return
  switch (page.props.ga_event) {
  case 'auth':
    return await loginEvent(page)
  }
}
